export const isLogin =  () => !!localStorage.getItem('token');
